<template>
  <div
    class="available-session-item"
    :style="session.is_educational ? '' : 'background-color: #f3f4f6;'"
  >
    <div class="session-info">
      <div class="session-header">
        <span class="session-title">{{ session.name }}</span>
        <span class="session-time-badge">
          {{ session.start_at_formatted }} - {{ session.end_at_formatted }}
        </span>
      </div>

      <div class="session-meta">
        <span v-if="session.room" class="meta-item">
          <i class="fa fa-map-marker"></i>
          {{ session.room.name }}
        </span>
        <span v-if="session.format" class="meta-item">
          <i class="fa fa-tag"></i>
          {{ session.format }}
        </span>
        <span v-if="session.credit_hours" class="meta-item">
          <i class="fa fa-clock-o"></i>
          {{ session.credit_hours }} hours
        </span>
        <span v-if="!session.is_educational" class="meta-item">
          {{ session.is_educational ? 'Educational' : 'Non Educational' }}
        </span>
      </div>

      <div v-if="session.presenters && session.presenters.length" class="session-presenters">
        <i class="fa fa-users"></i>
        {{ session.presenters.map(p => p.name).join(', ') }}
      </div>
    </div>

    <c-button
      theme="primary"
      icon="fa-plus"
      fill
      uppercase
      size="sm"
      :show-indicator="showIndicator"
      @click="$emit('add', session)"
    >Add</c-button>
  </div>
</template>

<script>
export default {
  name: 'SessionItem',
  props: {
    session: {
      type: Object,
      required: true
    },
    showIndicator: {
      type: Boolean,
      default: false
    }
  },
  emits: ['add']
};
</script>

<style scoped lang="scss">
.available-session-item {
  display: flex;
  gap: 15px;
  padding: 15px;
  border: 1px solid #e5e7eb;
  border-radius: var(--attendee-card-border-radius);
  cursor: pointer;
  transition: all 0.2s;
  background: white;

  &:hover {
    border-color: var(--attendee-primary-color, #4F46E5);
    box-shadow: 0 2px 8px rgba(79, 70, 229, 0.1);
  }

  @media (max-width: 900px) {
    flex-direction: column;
  }
}

.session-info {
  flex: 1;
}

.session-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
}

.session-title {
  font-weight: 600;
  color: var(--attendee-text-primary-color);
  font-size: 15px;
  line-height: 1.4;
}

.session-time-badge {
  font-size: 12px;
  background: #f3f4f6;
  padding: 4px 8px;
  border-radius: 4px;
  color: #4b5563;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
}

.session-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 8px;
}

.meta-item {
  font-size: 13px;
  color: #6b7280;
  display: flex;
  align-items: center;
  gap: 4px;

  i {
    opacity: 0.7;
  }
}

.session-presenters {
  font-size: 13px;
  color: #6b7280;
  display: flex;
  align-items: center;
  gap: 6px;

  i {
    opacity: 0.7;
  }
}
</style>
